var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.user)?_c('div',[_c('TopNav',{on:{"toggleLeftNav":_vm.toggleLeftNav}}),_c('settings-drawer'),_c('LeftNav',{ref:"leftNav"}),_c('v-container',{staticClass:"pa-6",attrs:{"fluid":""}},[_c('router-view')],1)],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }